import { Sun, Moon } from 'lucide-react';
import { Button } from '../../../ui/common-ui/button';
import { useGraphStore } from '../store/graphStore';

export function ThemeToggle() {
  const { theme, toggleTheme } = useGraphStore();

  return (
    <div className="glass-panel rounded-xl p-2 shadow-lg">
      <Button
        variant="outline"
        size="icon"
        onClick={toggleTheme}
        className="rounded-xl"
        title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {theme === 'dark' ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
      </Button>
    </div>
  );
}
